var value = window.value;
var value;
value = 0;
window.GlobalIncrementor = {
  next: function () {
    return ++value;
  }
};
window.value = value;